var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error-content"},[_c('img',{attrs:{"src":_vm.errorBg}}),_c('router-link',{attrs:{"to":{path:'/'}}},[_c('el-button',{staticClass:"mgT20",attrs:{"type":"primary","icon":"el-icon-refresh-right"}},[_vm._v("返回首页")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }